import { render, staticRenderFns } from "./ImportAndCreate.vue?vue&type=template&id=56804dbe&scoped=true"
import script from "./ImportAndCreate.vue?vue&type=script&lang=js"
export * from "./ImportAndCreate.vue?vue&type=script&lang=js"
import style0 from "./ImportAndCreate.vue?vue&type=style&index=0&id=56804dbe&prod&scoped=true&lang=css"
import style1 from "./ImportAndCreate.vue?vue&type=style&index=1&id=56804dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56804dbe",
  null
  
)

export default component.exports